const GetImage = (data) => {
  return data.map((item) => {
    let image = item.image[0].url;
    return { ...item, image };
  });
};

export const eachOrder = (data) => {
  return data.map((item) => {
    return item.dishes;
  });
};

export function Hot(dishes) {
  return dishes.filter((item) => {
    return item.Hot_sale === true;
  });
}

export function Paginate(dishes) {
  let itemsPerPage = 4;
  let lengthOfPage = Math.ceil(dishes.length / itemsPerPage);
  const new_array = Array.from({ length: lengthOfPage }, (_, index) => {
    const start = index * itemsPerPage;
    return dishes.slice(start, start + itemsPerPage);
  });
  return new_array;
}

export { GetImage as default };
